<template lang="html">
  <div class="mt-5">
    <vs-tabs
      alignment="center"
      :color="colorx"
      :position="isSmallerScreen ? 'top' : 'left'"
      class="tabs-shadow-none"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <vs-tab
        label="Alert"
        icon-pack="feather"
        icon="icon-bell"
        @click="colorx = '#479DD7'"
      >
        <div class="md:ml-4 md:mt-0 mt-4 ml-0">
          <vx-card no-shadow>
            <div v-if="data.alert.data.length">
              <div v-for="(alert, index1) in data.alert.data" :key="index1">
                <div class="vx-row mb-4">
                  <div class="vx-col sm:w-2/12 md:w-1/12 w-full">
                    <vs-row>
                      <vs-col
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                      >
                        <img
                          src="@/assets/images/tabler-icon/bell-ringing-red.svg"
                          style="width: 30px;"
                          class="mt-1 mb-2"
                          alt="Icon Bell Ringing"
                        />
                      </vs-col>
                    </vs-row>
                  </div>
                  <div class="vx-col sm:w-7/12 md:w-9/12 w-full">
                    <vs-row>
                      <vs-col
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="center"
                      >
                        <span class="font-semibold text-danger">
                          {{ alert.ref_alert.description }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="center"
                        class="mb-2"
                      >
                        <span><span class="font-semibold">{{ alert.gps.device_name }}</span> - {{ alert.alert_text }}</span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="center"
                        class="mb-3"
                      >
                        <small
                          class="font-weight-bold text-primary"
                          v-if="!alert.show_address"
                          @click="getAddress('alert', index1)"
                        >
                          <u style="cursor: pointer;">Lihat alamat</u>
                        </small>
                        <small v-else>
                          {{ alert.address }}
                        </small>
                      </vs-col>
                    </vs-row>
                  </div>
                  <div class="vx-col sm:w-3/12 md:w-2/12 w-full">
                    <vs-col
                      vs-type="flex"
                      :vs-justify="!isSmallerScreen ? 'right' : 'center'"
                    >
                      <small class="font-semibold">
                        {{ alert.time }}
                      </small>
                    </vs-col>
                  </div>
                </div>
                <div class="vx-row mb-2 mx-2" style="border-bottom: 2px solid #F5F5F5">
                </div>
              </div>
            </div>
            <div v-else>
              <b-row>
                <b-col cols="12" md="4" align-self="center">
                  <img
                    src="@/assets/images/freepik/inbox-alert.svg"
                    alt="icon empty state alert"
                    class="w-full"
                  />
                </b-col>
                <b-col cols="12" md="8" align-self="center" :class="isSmallerScreen ? 'text-center' : 'text-left'">
                  <h4 style="color:rgb(75, 70, 92 / 90%); font-weight:800">Tidak ada alarm aktif pada kendaraanmu.</h4>
                  <small style="color:rgb(75 70 92 / 50%); font-weight:500">Tenang aja, unit GPS.ID akan memberitahumu jika ada yang tidak normal dengan kendaraanmu.</small>
                </b-col>
              </b-row>
            </div>

            <vs-button
              color="primary"
              type="filled"
              class="mt-5"
              id="btnAlert"
              @click="loadAlert"
              v-show="data.alert.loading"
            ><b>Load More</b>
            </vs-button>

          </vx-card>
        </div>
      </vs-tab>

      <vs-tab
        label="Info"
        icon-pack="feather"
        icon="icon-info"
        @click="colorx = '#479DD7'"
      >
        <div class="md:ml-4 md:mt-0 mt-4 ml-0">
          <vx-card no-shadow>
            <div v-if="data.info.data.length">
              <div v-for="(info, index2) in data.info.data" :key="index2">
                <div class="vx-row mb-4">
                  <div class="vx-col sm:w-2/12 md:w-1/12 w-full">
                    <vs-row>
                      <vs-col
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                      >
                        <img
                          src="@/assets/images/tabler-icon/info-circle-yellow.svg"
                          style="width: 30px;"
                          class="mt-1 mb-2"
                          alt="Icon Info Circle"
                        />
                      </vs-col>
                    </vs-row>
                  </div>
                  <div class="vx-col sm:w-7/12 md:w-9/12 w-full">
                    <vs-row>
                      <vs-col
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="center"
                        style="cursor: pointer;"
                      >
                        <p class="font-semibold">
                          {{ info.title }}
                        </p>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="center"
                        class="mb-3"
                      >
                        <small>{{info.description}}</small>

                        <!-- <small>{{info.description}}Paket di unit <b>B 1234 TTG</b> anda segera habiss, Segera isi ulang paket langganan anda untuk terus menikmati fitur fitur GPS.Id</small> -->
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="center"
                        class="mb-3"
                        >
                        <small
                          class="font-weight-bold text-primary"
                          @click=""
                        >
                          <u style="cursor: pointer;">Lihat detail</u>
                        </small>
                      </vs-col>
                    </vs-row>
                  </div>
                  <div class="vx-col sm:w-3/12 md:w-2/12 w-full">
                    <vs-col
                      vs-type="flex"
                      :vs-justify="!isSmallerScreen ? 'right' : 'center'"
                    >
                      <small class="font-semibold">
                        {{info.created_at}}
                      </small>
                    </vs-col>
                  </div>
                </div>
              </div>
              <!-- <div class="vx-row mb-4">
                <div class="vx-col sm:w-2/12 md:w-1/12 w-full">
                  <vs-row>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                    >
                      <img
                        src="@/assets/images/tabler-icon/info-circle-yellow.svg"
                        style="width: 30px;"
                        class="mt-1 mb-2"
                        alt="Icon Info Circle"
                      />
                    </vs-col>
                  </vs-row>
                </div>
                <div class="vx-col sm:w-7/12 md:w-9/12 w-full">
                  <vs-row>
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="center"
                      style="cursor: pointer;"
                    >
                      <p class="font-semibold">
                        Paket Langganan Anda Segera Habis
                      </p>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="center"
                      class="mb-3"
                    >
                      <small>Paket di unit <b>B 1234 TTG</b> anda segera habiss, Segera isi ulang paket langganan anda untuk terus menikmati fitur fitur GPS.Id</small>
                    </vs-col>
                  </vs-row>
                </div>
                <div class="vx-col sm:w-3/12 md:w-2/12 w-full">
                  <vs-col
                    vs-type="flex"
                    :vs-justify="!isSmallerScreen ? 'right' : 'center'"
                  >
                    <small class="font-semibold">
                      22/02/2023, 09:00
                    </small>
                  </vs-col>
                </div>
              </div>
              <div class="vx-row mb-2 mx-2" style="border-bottom: 2px solid #F5F5F5">
              </div> -->

              <!-- <div class="vx-row mb-4">
                <div class="vx-col sm:w-2/12 md:w-1/12 w-full">
                  <vs-row>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                    >
                      <img
                        src="@/assets/images/tabler-icon/info-circle-yellow.svg"
                        style="width: 30px;"
                        class="mt-1 mb-2"
                        alt="Icon Info Circle"
                      />
                    </vs-col>
                  </vs-row>
                </div>
                <div class="vx-col sm:w-7/12 md:w-9/12 w-full">
                  <vs-row>
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="center"
                      style="cursor: pointer;"
                    >
                      <p class="font-semibold">
                        Paket Langganan Anda Segera Habis
                      </p>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="center"
                      class="mb-3"
                    >
                      <small>Paket di unit <b>B 1234 TTG</b> anda segera habiss, Segera isi ulang paket langganan anda untuk terus menikmati fitur fitur GPS.Id</small>
                    </vs-col>
                  </vs-row>
                </div>
                <div class="vx-col sm:w-3/12 md:w-2/12 w-full">
                  <vs-col
                    vs-type="flex"
                    :vs-justify="!isSmallerScreen ? 'right' : 'center'"
                  >
                    <small class="font-semibold">
                      22/02/2023, 09:00
                    </small>
                  </vs-col>
                </div>
              </div>
              <div class="vx-row mb-2 mx-2" style="border-bottom: 2px solid #F5F5F5">
              </div> -->


              <!-- <div class="vx-row mb-4">
                <div class="vx-col sm:w-2/12 md:w-1/12 w-full">
                  <vs-row>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-align="center"
                    >
                      <img
                        src="@/assets/images/tabler-icon/info-circle-yellow.svg"
                        style="width: 30px;"
                        class="mt-1 mb-2"
                        alt="Icon Info Circle"
                      />
                    </vs-col>
                  </vs-row>
                </div>
                <div class="vx-col sm:w-7/12 md:w-9/12 w-full">
                  <vs-row>
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="center"
                      style="cursor: pointer;"
                    >
                      <p class="font-semibold">
                        Paket Langganan Anda Segera Habis
                      </p>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-justify="left"
                      vs-align="center"
                      class="mb-3"
                    >
                      <small>Paket di unit <b>B 1234 TTG</b> anda segera habiss, Segera isi ulang paket langganan anda untuk terus menikmati fitur fitur GPS.Id</small>
                    </vs-col>
                  </vs-row>
                </div>
                <div class="vx-col sm:w-3/12 md:w-2/12 w-full">
                  <vs-col
                    vs-type="flex"
                    :vs-justify="!isSmallerScreen ? 'right' : 'center'"
                  >
                    <small class="font-semibold">
                      22/02/2023, 09:00
                    </small>
                  </vs-col>
                </div>
              </div>
              <div class="vx-row mb-2 mx-2" style="border-bottom: 2px solid #F5F5F5">
              </div> -->

            </div>
            <div v-else>
              <b-row>
                <b-col cols="12" md="4" align-self="center">
                  <img
                    src="@/assets/images/freepik/inbox-info.svg"
                    alt="icon empty state info"
                    class="w-full"
                  />
                </b-col>
                <b-col cols="12" md="8" align-self="center" :class="isSmallerScreen ? 'text-center' : 'text-left'">
                  <h4 style="color:rgb(75, 70, 92 / 90%); font-weight:800">Belum ada informasi terbaru untuk kamu.</h4>
                  <small style="color:rgb(75 70 92 / 50%); font-weight:500">Kami akan mengirimkan notifikasi jika ada informasi terbaru.</small>
                </b-col>
              </b-row>
            </div>

            <vs-button
              color="primary"
              type="filled"
              class="mt-5"
              id="btnInfo"
              @click="loadInfo"
              v-show="data.info.loading"
            ><b>Load More</b>
            </vs-button>
          </vx-card>
        </div>
      </vs-tab>

      <vs-tab
        label="Pembayaran"
        icon-pack="feather"
        icon="icon-credit-card"
        @click="colorx = '#479DD7'"
      >
        <div class="md:ml-4 md:mt-0 mt-4 ml-0">
          <vx-card no-shadow>
            <div v-if="data.pembayaran.data.length">
              <div v-for="(pembayaran, index3) in data.pembayaran.data" :key="index3">
                <div class="vx-row mb-4">
                  <div class="vx-col sm:w-2/12 md:w-1/12 w-full">
                    <vs-row>
                      <vs-col
                        vs-type="flex"
                        vs-justify="center"
                        vs-align="center"
                      >
                        <img
                          src="@/assets/images/tabler-icon/card-purple.svg"
                          style="width: 30px;"
                          class="mt-1 mb-2"
                          alt="Icon Card"
                        />
                      </vs-col>
                    </vs-row>
                  </div>
                  <div class="vx-col sm:w-7/12 md:w-9/12 w-full">
                    <vs-row>
                      <vs-col
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="center"
                      >
                        <p class="font-semibold">
                          {{ pembayaran.title }}
                        </p>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="center"
                        class="mb-3"
                      >
                        <small>{{ pembayaran.description }}</small>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        vs-justify="left"
                        vs-align="center"
                        class="mb-3"
                        >
                        <small
                          class="font-weight-bold text-primary"
                          @click="showPopup=true"
                        >
                          <u style="cursor: pointer;">Lihat detail</u>
                        </small>
                      </vs-col>
                    </vs-row>
                  </div>
                  <div class="vx-col sm:w-3/12 md:w-2/12 w-full">
                    <vs-col
                      vs-type="flex"
                      :vs-justify="!isSmallerScreen ? 'right' : 'center'"
                    >
                      <small class="font-semibold">
                        {{ pembayaran.created_at }}
                      </small>
                    </vs-col>
                  </div>
                </div>
              </div>
              <div class="vx-row mb-2 mx-2" style="border-bottom: 2px solid #F5F5F5">
              </div>
            </div>
            <div v-else>
              <b-row>
                <b-col cols="12" md="4" align-self="center">
                  <img
                    src="@/assets/images/freepik/inbox-pembayaran.svg"
                    alt="icon empty state pembayaran"
                    class="w-full"
                  />
                </b-col>
                <b-col cols="12" md="8" align-self="center" :class="isSmallerScreen ? 'text-center' : 'text-left'">
                  <h4 style="color:rgb(75, 70, 92 / 90%); font-weight:800">Belum ada transaksi di akunmu.</h4>
                  <small style="color:rgb(75 70 92 / 50%); font-weight:500">Nanti kamu bisa melihat seluruh informasi transaksimu di halaman ini.</small>
                </b-col>
              </b-row>
            </div>


            <!-- <vs-button color="primary" type="filled" class="mt-5"><b>Load More</b></vs-button> -->
            <vs-button
              color="primary"
              type="filled"
              class="mt-5"
              id="btnPembayaran"
              @click="loadPembayaran"
              v-show="data.pembayaran.loading"
            ><b>Load More</b>
            </vs-button>
          </vx-card>
        </div>
        <vs-popup classContent="popup-example"
                title="Info Detail"
                :active.sync="showPopup">
          <template>
            <div class="vx-row mb-3">
              <div class="vx-col sm:w-1/2 w-full">
                <label class="vs-input--label font-weight-bold text-primary">Informasi Order</label>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col sm:w-1/3 mr-4 w-full">
                <label class="vs-input--label">Order ID</label>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <label class="vs-input--label">INV-001525072164492000</label>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col sm:w-1/2 w-full">
                <label class="vs-input--label font-weight-bold text-primary">Detail Pembayaran</label>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col sm:w-1/2 w-full">
                <label class="vs-input--label font-weight-bold text-primary">Unit Detail </label>
              </div>
            </div>

          </template>
        </vs-popup>
      </vs-tab>

    </vs-tabs>
  </div>
</template>

<script>

export default {
  components: {},

  data() {
    return {
      loading: true,
      colorx: '#479DD7',
      showPopup:false,

      actor: {},

      data: {
        alert: {
          page: 1,
          per_page: 10,
          data: [],
          total: 0,
          loading: false,
        },
        info: {
          page: 1,
          per_page: 10,
          data: [],
          total: 0,
          loading: false,
        },
        pembayaran: {
          page: 1,
          per_page: 10,
          data: [],
          total: 0,
          loading: false,
        },
      },

      notify: 'Server Error'
    }
  },

  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },

  watch: {
    'data.alert.page'() {
      this.alert_table()
    },
    'data.info.page'() {
      this.info_table()
    },
    'data.pembayaran.page'() {
      this.pembayaran_table()
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http.get(`${this.$api.endpoint}/user/profile`, {
      headers: {
        Authorization: `Bearer ${this.token}`
      }
    }).then(res => {
      this.actor = res.data.message.data
    }).catch(error => {
      this.$gf.httpErrorHandler(error)
    })

    this.alert_table()
    this.info_table()
    this.pembayaran_table()

  },

  mounted() {},

  methods: {
    loadAlert() {
      this.loadData('#btnAlert')
      this.data.alert.page = (this.data.alert.page + 1)
    },

    loadInfo() {
      this.loadData('#btnInfo')
      this.data.info.page = (this.data.info.page + 1)
    },

    loadPembayaran() {
      this.loadData('#btnPembayaran')
      this.data.pembayaran.page = (this.data.pembayaran.page + 1)
    },

    loadData(el) {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: el,
        scale: 0.45
      })
    },

    sortTime(list_data, name) {

      if (name == 'alert') {
        list_data.sort(function(a, b) {
          return new Date(b.time) - new Date(a.time);
        })
        this.data.alert.data = list_data
        return this.data.alert.data
      }

      if (name == 'info') {
        list_data.sort(function(a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        })
        this.data.info.data = list_data
        return this.data.info.data
      }
      if (name == 'pembayaran') {
        list_data.sort(function(a, b) {
          return new Date(b.created_at) - new Date(a.created_at);
        })
        this.data.pembayaran.data = list_data
        return this.data.pembayaran.data
      }

    },

    getAddress(type, index) {
      let item = this.data[type].data[index]
      if (!item.address) {
        this.$http.get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: item.lat,
            longitude: item.lon
          }
        })
        .then((res) => {
          this.data[type].data[index].show_address = true
          this.data[type].data[index].address = res.data.message
        })
      } else {
        this.data[type].data[index].show_address = true
      }
    },

    info_table(){
      let config = {
        headers: {'Authorization': `Bearer ${this.token}`},
        params: {
          page: this.data.info.page,
          per_page: this.data.info.per_page
        },
      }

      this.$http.get(`${this.$api.endpoint}/inbox/info_payment`, config)
      .then(res => {
        const r = res.data.data
        this.data.info.total = r.total
        this.data.info.loading = r.data_list.length == 10 ? true : false
        let data_temp = this.data.info.data.concat(r.data_list)
        this.sortTime(data_temp, 'info')

        this.$vs.loading.close(`#btnInfo > .con-vs-loading`)
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },

    pembayaran_table() {
      let config = {
        headers: {'Authorization': `Bearer ${this.token}`},
        params: {
          page: this.data.pembayaran.page,
          per_page: this.data.pembayaran.per_page
        },
      }

      this.$http.get(`${this.$api.endpoint}/inbox/info_payment`, config)
      .then(res => {
        const r = res.data.data
        this.data.pembayaran.total = r.total
        this.data.pembayaran.loading = r.data_list.length == 10 ? true : false
        let data_temp = this.data.pembayaran.data.concat(r.data_list)
        this.sortTime(data_temp, 'pembayaran')

        this.$vs.loading.close(`#btnPembayaran > .con-vs-loading`)
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },
    alert_table() {
      let config = {
        headers: {'Authorization': `Bearer ${this.token}`},
        params: {
          page: this.data.alert.page,
          per_page: this.data.alert.per_page,
        },
      }

      this.$http.get(`${this.$api.endpoint}/alert/datatable_inbox`, config)
      .then(res => {
        const r = res.data.data
        this.data.alert.total = r.total
        this.data.alert.loading = r.list_data.length == 10 ? true : false
        let data_temp = []
        r.list_data.map(item => {
          data_temp.push({
            ...item,
            show_address: false
          })
        })

        let alert_temp  = this.data.alert.data.concat(data_temp)
        this.sortTime(alert_temp, 'alert')
        this.$vs.loading.close(`#btnAlert > .con-vs-loading`)

      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}

.center-vs-tab {
  justify-content: center;
}
</style>
